import React from "react";
import {
  Avatar,
  Box,
  // Button,
  Chip,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import BusinessIcon from "@material-ui/icons/Business";
import LanguageIcon from "@material-ui/icons/Language";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import EditIcon from "@material-ui/icons/Edit";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import CustomButton from "../customButton/CustomButton";

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: 20,
    padding: 32,
    color: "#fff",
    position: "relative",
    overflow: "hidden",
    background:
      "linear-gradient(90deg,#13105A 0%, #58005E 45%, #D6002A 100%)",
      zIndex:'1',
  },

  content: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: 24,
    },
  },

  leftSection: {
    display: "flex",
    alignItems: "center",

    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },

  avatarWrapper: {
    position: "relative",
    marginRight: 32,
  },

  avatar: {
    width: '180px !important',
    height: '180px !important',
    border: "4px solid white",
    '& img':{
      objectFit:'initial'
    }
  },


  editAvatar: {
    position: "absolute",
    bottom: 10,
    right: 0,
    width: 42,
    height: 42,
    borderRadius: "50%",
    background: "#7C3AED",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    border: "3px solid white",
  },

  titleRow: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginBottom: 10,
  },

  title: {
    fontWeight: 700,
    fontSize: 42,

    [theme.breakpoints.down("sm")]: {
      fontSize: 28,
    },
  },

  role: {
    fontSize: '18px !important',
    marginBottom: '16px !important',
    opacity: 0.95,
  },

  metaRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: 24,
    marginBottom: 20,
  },

  metaItem: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    fontSize: 16,
  },

  recruiterChip: {
    background: "rgba(255,255,255,0.15)",
    color: "#fff",
    borderRadius: 10,
    fontWeight: 500,
  },

  addButton: {
    background: "#fff",
    color: "#6D28D9",
    borderRadius: 12,
    padding: "12px 24px",
    fontWeight: 700,
    textTransform: "none",

    "&:hover": {
      background: "#f8f8f8",
    },
  },

  rightCircle: {
    position: "absolute",
    right: -120,
    top: -80,
    width: 400,
    height: 400,
    borderRadius: "50%",
    border: "50px solid rgba(255,255,255,0.08)",
    zIndex:'-1'
  },
  btngrp: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem'
  }

}));

const ProfileHero = ({
  profileImage,
  email,
  fullName,
  jobTitle,
  company,
  country,
  division,
  isEnableEditProfileButton,
  recruiterAvailable = false,
  onAddToTeam,
  onEditPhoto = ()=>{},
  onEdit=()=>{},
}) => {
  const classes = useStyles();

  // console.log("profileImage===>", profileImage)

  return (
    <Box className={classes.root}>
      <div className={classes.rightCircle} />

      <div className={classes.content}>
        <div className={classes.leftSection}>
                  <div className={classes.avatarWrapper}>
                      <Avatar className={classes.avatar} alt={fullName} src={profileImage} />
                        {isEnableEditProfileButton &&
                          <button 
                            type="button"
                            className={classes.editAvatar}
                            onClick={onEditPhoto}
                          >
                            <EditIcon fontSize="small" />
                          </button>
                        }
                  </div>

          <div>
            <div className={classes.titleRow}>
              <Typography className={classes.title}>
                {fullName}
              </Typography>

              <VerifiedUserIcon />
            </div>

            <Typography className={classes.role}>
              {email}
            </Typography>
            <Typography className={classes.role}>
              {jobTitle}
            </Typography>

            <div className={classes.metaRow}>
              {/* <div className={classes.metaItem}>
                <BusinessIcon />
                {company}
              </div> */}

              <div className={classes.metaItem}>
                <LanguageIcon />
                {country}
              </div>

              <div className={classes.metaItem}>
                <AccountTreeIcon />
                {division}
              </div>
            </div>

            <Chip
              className={classes.recruiterChip}
              label={
                recruiterAvailable
                  ? "Available to be recruited"
                  : "Recruited is not Available"
              }
            />
          </div>
        </div>

      <div className={classes.btngrp}>
        {isEnableEditProfileButton &&
          <CustomButton
            variant="contained"
            startIcon={<EditIcon />}
            className={classes.addButton}
            onClick={onEdit}
          >
            Edit Profile
          </CustomButton> 
        }


        {/* if login user and bench user email are same so  hide the Add a team button */}
        {/* no need to add own idea as a team member of idea */}
{
  !isEnableEditProfileButton && <CustomButton
  variant="contained"
  className={classes.addButton}
  startIcon={<PersonAddIcon />}
  onClick={onAddToTeam}
  disabled={!recruiterAvailable}
>
  Add to Team
</CustomButton> 
}
        
        

        </div>

      </div>
    </Box>
  );
};

export default ProfileHero;